// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2IGFl","name":"Header_name__2UX7t","birthday":"Header_birthday__3z8x7","skeleton":"Header_skeleton__2BXAV"};